import './loading.css';

function Loading() {
  return (
    <div>
      <div className="spinner" />
      <p>Loading...</p>
    </div>
  );
}

export default Loading;
